// servicioUtils.js
import {
  getDoc,
  doc,
  updateDoc,
  setDoc
} from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { toast } from "sonner";
import dayjs from "dayjs";

export const addToCartService = async (servicio, userData) => {
  try {
    if (!userData) {
      toast.error("Inicia sesión para crear un carrito.");
      return;
    }

    const userCartRef = doc(db, "carritos", userData.uid);
    const userCartDoc = await getDoc(userCartRef);

    if (userCartDoc.exists()) {
      const userCartData = userCartDoc.data();
      const servicios = userCartData.servicios || [];
      
      const existingProductIndex = servicios.findIndex(
        (cartProduct) => cartProduct.id === servicio.id
      );

      let updatedServicios = [...servicios];

      if (existingProductIndex !== -1) {
        // Incrementar cantidad
        updatedServicios[existingProductIndex].cantidad = (updatedServicios[existingProductIndex].cantidad || 1) + 1;
      } else {
        // Agregar nuevo
        updatedServicios.push({
          id: servicio.id,
          cantidad: 1
        });
      }

      await updateDoc(userCartRef, { servicios: updatedServicios });
      toast.success("Servicio agregado al carrito.");
    } else {
      // Crear carrito nuevo
      await setDoc(userCartRef, {
        servicios: [{ id: servicio.id, cantidad: 1 }],
        productos: []
      });
      toast.success("Servicio agregado al carrito.");
    }
  } catch (error) {
    console.error("Error al agregar el servicio al carrito:", error.message);
    toast.error("No se pudo agregar al carrito.");
  }
};

export const addToCartServicioDetalle = async (
  servicio,
  userData,
  cantidad,
  cantidadDuracion,
  diaSeleccionado,
  horaInicioSeleccionada
) => {
  try {
    if (!userData) {
      toast.error("Inicia sesión para crear un carrito.");
      return false;
    }
    if (!servicio || !diaSeleccionado || !horaInicioSeleccionada) {
      toast.error("Elige la fecha y la hora de tu reserva.");
      return false;
    }

    // Un servicio por tipo de duración guarda solo los datos que necesita
    const item = { id: servicio.id, diaSeleccionado, horaInicioSeleccionada };
    if (servicio.duracion !== "unico") {
      const dur = Math.max(1, parseInt(cantidadDuracion) || 1);
      item.cantidadDuracion = dur;
      if (servicio.duracion === "dia") {
        item.diaFinSeleccionado = dayjs(diaSeleccionado).add(dur, "day").format("YYYY-MM-DD");
      }
    }
    if (servicio.stock) item.cantidad = Math.min(Math.max(1, parseInt(cantidad) || 1), servicio.stock);

    const userCartRef = doc(db, "carritos", userData.uid);
    const userCartDoc = await getDoc(userCartRef);

    if (userCartDoc.exists()) {
      const servicios = userCartDoc.data().servicios || [];
      const existe = servicios.some((s) => s.id === servicio.id);
      const actualizados = existe
        ? servicios.map((s) => (s.id === servicio.id ? item : s))
        : [...servicios, item];
      await updateDoc(userCartRef, { servicios: actualizados });
      toast.success(existe ? "Reserva actualizada." : "Servicio agregado al carrito.");
    } else {
      await setDoc(userCartRef, { servicios: [item], productos: [] });
      toast.success("Servicio agregado al carrito.");
    }
    return true;
  } catch (error) {
    console.error("Error al agregar el servicio al carrito:", error.message);
    toast.error("No se pudo agregar el servicio al carrito.");
    return false;
  }
};

export const eliminarServicioCarrito = async (userData, servicioId) => {
  try {
    if (!userData) {
      toast.error("Inicia sesión para acceder al carrito.");
      return;
    }
    
    // Obtener la referencia del carrito del usuario
    const userCartRef = doc(db, "carritos", userData.uid);
    const userCartDoc = await getDoc(userCartRef);

    if (userCartDoc.exists()) {
      // Si el carrito existe, eliminar el servicio con el servicioId proporcionado
      const updatedCartItems = userCartDoc
        .data()
        .servicios.filter((cartItem) => cartItem.id !== servicioId);
      
      // Actualizar el carrito en la base de datos sin el servicio eliminado
      await updateDoc(userCartRef, {
        servicios: updatedCartItems,
      });

      // Mostrar un mensaje de éxito
      toast.success("Servicio eliminado del carrito correctamente.");
    } else {
      toast.error("El carrito no existe.");
    }
  } catch (error) {
    console.error("Error al eliminar el servicio del carrito:", error.message);
    toast.error("Ocurrió un error al eliminar el servicio del carrito.");
  }
};



// Función para obtener los datos de un producto por su ID
export const getServicioPorId = async (id) => {
  try {
    // Obtener el documento del producto con el ID proporcionado
    const infoProductDoc = doc(db, "servicios", id);
    const infoProductSnapshot = await getDoc(infoProductDoc);

    // Verificar si el documento existe
    if (infoProductSnapshot.exists()) {
      // Obtener los datos del producto y devolverlos
      const infoProductData = infoProductSnapshot.data();
      return { id: infoProductSnapshot.id, ...infoProductData };
    } else {
      // Si el documento no existe, devolver un objeto vacío
      console.warn("El servicio con el ID proporcionado no existe.");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener los datos del servicio:", error.message);
    return null;
  }
}